import { render } from "./ResetPwdView.vue?vue&type=template&id=51f9764e&scoped=true"
import script from "./ResetPwdView.vue?vue&type=script&lang=js"
export * from "./ResetPwdView.vue?vue&type=script&lang=js"

import "./ResetPwdView.vue?vue&type=style&index=0&id=51f9764e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f9764e"]])

export default __exports__